import { addEventListeners, onHover } from "../../../helpers/events";
export var initLabel = function (column) {
    column.getElement().querySelectorAll('select[data-label="update"]').forEach(function (select) {
        select.addEventListener('change', function () {
            var labelSetting = column.getElement().querySelector('input.ac-setting-input_label');
            var option = select.selectedOptions.length > 0 ? select.selectedOptions[0] : null;
            if (labelSetting && option) {
                labelSetting.value = option.innerHTML;
                labelSetting.dispatchEvent(new Event('change'));
            }
        });
    });
    setTimeout(function () {
        var label = column.getElement().querySelector('.column_label .toggle');
        if (label && label.offsetWidth < 10) {
            label.innerText = column.getType();
        }
    }, 50);
};
export var initLabelSettingEvents = function (column) {
    var labelInput = column.getElement().querySelector('.ac-column-setting--label input');
    if (labelInput) {
        addEventListeners(labelInput, ['change', 'keyup'], function () { return changeLabel(labelInput, column); });
    }
};
export var initLabelTooltipsEvent = function (column) {
    column.getElement().querySelectorAll('.col-label .label').forEach(function (label) {
        onHover(label, function () { return hoverTooltip(label, 'block'); }, function () { return hoverTooltip(label, 'none'); });
    });
};
var hoverTooltip = function (label, display) {
    var related = label.closest('.col-label').querySelector('div.tooltip');
    if (related) {
        related.style.display = display;
    }
};
var changeLabel = function (labelInput, column) {
    column.getElement().querySelector('td.column_label .inner > a.toggle').innerHTML = labelInput.value;
};
